
const LANGUAGE_OPTION_KEYS = [
  { code: "en", key: "LANG_UNITED_STATES" },
  { code: "jp", key: "LANG_JAPAN" },
  { code: "kr", key: "LANG_SOUTH_KOREA" },
  { code: "pt", key: "LANG_PORTUGAL" },
  { code: "pl", key: "LANG_POLAND" },
  { code: "ru", key: "LANG_RUSSIA" },
  { code: "tw", key: "LANG_TAIWAN" },
  { code: "de", key: "LANG_GERMANY" },
  { code: "es", key: "LANG_SPAIN" },
  { code: "fr", key: "LANG_FRANCE" },
  { code: "it", key: "LANG_ITALY" },
];

export default {
  name: "xfans-footer",
  data() {
    return {
      tips: true,
      storeUrl: "",
      email: "",
      emailError: "",
      successTimer: null,
      successVisible: false,
      submitDebounce: false,
      languageOpen: false,
      languageSwitching: false, // 防止连续点语种重复请求
      currentLocale: "en",
    };
  },
  computed: {
    languageOptions() {
      return LANGUAGE_OPTION_KEYS.map((item) => ({
        code: item.code,
        label: this.$t(`page.${item.key}`),
      }));
    },
    currentLanguageLabel() {
      const found = this.languageOptions.find(
        (item) => item.code === this.currentLocale
      );
      return found ? found.label : this.$t("page.LANG_UNITED_STATES");
    },
  },
  mounted() {
    this.currentLocale = this.$i18n.locale || "en";
    if (process.client) {
      document.addEventListener("click", this.handleDocumentClick);
    }
  },
  watch: {
    "$i18n.locale"(locale) {
      this.currentLocale = locale;
    },
  },
  beforeDestroy() {
    if (process.client) {
      document.removeEventListener("click", this.handleDocumentClick);
    }
  },
  methods: {
    toggleLanguageDropdown() {
      this.languageOpen = !this.languageOpen;
    },
    handleDocumentClick(event) {
      if (
        this.$refs.languageSelector &&
        !this.$refs.languageSelector.contains(event.target)
      ) {
        this.languageOpen = false;
      }
    },
    /** 切换页脚语种，并同步社区 /language/siteLang */
    async selectLanguage(code) {
      if (code === this.currentLocale || this.languageSwitching) {
        this.languageOpen = false;
        return;
      }
      this.languageOpen = false;
      this.languageSwitching = true;
      try {
        await this.$loadLanguageAsync(code);
        const res = await this.$global.siteLang({ lang: code });
        if (!res || res.code !== 200) {
          this.$message.error((res && res.msg) || this.$t("page.UNKNOWN_ERROR"));
        }
      } catch (e) {
        this.$message.error(this.$t("page.UNKNOWN_ERROR"));
      } finally {
        this.languageSwitching = false;
      }
    },
    async subscribe() {
      if (this.submitDebounce) return;
      this.submitDebounce = true;
      setTimeout(() => {
        this.submitDebounce = false;
      }, 1000);
      this.emailError = "";
      if (!this.email) {
        this.emailError = this.$t('page.EMAIL_REQUIRED');
        return;
      }
      // Simple email regex or a more complex one.
      // User asked for regex validation.
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(this.email)) {
        this.emailError = this.$t('page.EMAIL_INVALID');
        return;
      }
      try {
        const res = await this.$global.subscribe({ email: this.email });
        if (res && +res.code === 200) {
          if (this.successTimer) {
            clearTimeout(this.successTimer);
            this.successTimer = null;
          }
          this.successVisible = true;
          this.successTimer = setTimeout(() => {
            this.successVisible = false;
            this.successTimer = null;
          }, 3000);
          this.email = "";
        } else {
          this.emailError = (res && res.msg) || this.$t('page.SUBSCRIPTION_FAILED');
        }
      } catch (e) {
        this.emailError = this.$t('page.NETWORK_ERROR');
      }
    },
    accept() {
      localStorage.setItem("cookieTips", true);
      this.tips = false;
    },
    async getStoreJumpUrl() {
      let res = await this.$global.storeJumpUrl();
      // console.log(res.data, 'res.data111');
      res.code == 200
        ? (this.storeUrl = res.data)
        : (this.storeUrl = "https://www.xp-pen.com/store/");
    },
  },
};
